import { render, staticRenderFns } from "./CourseControls.vue?vue&type=template&id=1a09d2dc&"
import script from "./CourseControls.vue?vue&type=script&lang=js&"
export * from "./CourseControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports